import * as React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { LucideIcon } from 'utils/lucideIcon'
import './styles.scss'
import { t as translate, useTranslation } from 'translations'

export const VIA_SEARCH_PARAM = 'viaSearch'

interface SearchScopeBadgeProps {
    keepParams?: string[]
}

export const SearchScopeBadge = ({ keepParams = [] }: SearchScopeBadgeProps): JSX.Element | null => {
    const { t } = useTranslation()
    const history = useHistory()
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const label = params.get(VIA_SEARCH_PARAM)

    if (!label) {
        return null
    }

    const showDefaultView = () => {
        const kept = new URLSearchParams()
        keepParams.forEach((key) => {
            const value = params.get(key)
            if (value !== null) {
                kept.set(key, value)
            }
        })
        history.replace({ pathname: location.pathname, search: kept.toString() })
    }

    return (
        <ScopeBadge
            label={label}
            onClear={showDefaultView}
            clearLabel={t('uiComponents.searchScopeBadge.removeFiltersAriaLabel')}
            clearTitle={t('uiComponents.searchScopeBadge.backToDefault')}
        />
    )
}

interface ScopeBadgeProps {
    label: string
    onClear: () => void
    title?: string
    clearLabel?: string
    clearTitle?: string
}

export const ScopeBadge = ({
    label,
    onClear,
    title = translate('uiComponents.searchScopeBadge.appliedBySearch'),
    clearLabel = translate('uiComponents.searchScopeBadge.clearSearch'),
    clearTitle = translate('uiComponents.searchScopeBadge.clear'),
}: ScopeBadgeProps): JSX.Element => (
    <div className="search-scope-badge" title={title}>
        <LucideIcon iconName="Search" size={13} />
        <span className="search-scope-badge-label">{label}</span>
        <button
            type="button"
            className="search-scope-badge-clear"
            onClick={onClear}
            aria-label={clearLabel}
            title={clearTitle}
        >
            <LucideIcon iconName="X" size={13} />
        </button>
    </div>
)
